var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markings-list"},_vm._l((_vm.list),function(item){return _c('MarkingsAssignListItem',{key:item.id,attrs:{"item":item,"disabled":_vm.isElementDisabled(item),"full-disabled":!_vm.lowerLevel},on:{"select-item":function($event){return _vm.$emit('select-item', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }